// Merge a project's content-facing context into an editor chrome's
// context. Chrome values (and `extras`) take precedence. Build/runtime
// flags (useReset, globalTheme, …) must be stripped with
// `splitProjectForEditor` before calling — they belong to the chrome.
export function mergeProjectIntoEditorContext (editorCtx, projectContent, extras = {}) {
  const {
    components: extraComponents,
    functions: extraFunctions,
    methods: extraMethods,
    state: extraState,
    ...rest
  } = extras || {}

  return {
    ...editorCtx,
    polyglot: projectContent?.polyglot,
    // Chrome libraries first so brand DS tokens survive project overlays.
    sharedLibraries: [
      ...(Array.isArray(editorCtx?.sharedLibraries) ? editorCtx.sharedLibraries : []),
      ...(Array.isArray(projectContent?.sharedLibraries) ? projectContent.sharedLibraries : [])
    ],
    fetch: projectContent?.fetch ?? editorCtx?.fetch,
    designSystem: projectContent?.designSystem ?? editorCtx?.designSystem,
    snippets: { ...(projectContent?.snippets || {}), ...(editorCtx?.snippets || {}) },
    files: { ...(projectContent?.files || {}), ...(editorCtx?.files || {}) },
    components: {
      ...(projectContent?.components || {}),
      ...(editorCtx?.components || {}),
      ...(extraComponents || {})
    },
    functions: {
      ...(projectContent?.functions || {}),
      ...(editorCtx?.functions || {}),
      ...(extraFunctions || {})
    },
    methods: {
      ...(projectContent?.methods || {}),
      ...(editorCtx?.methods || {}),
      ...(extraMethods || {})
    },
    state: {
      ...(projectContent?.state || {}),
      ...(editorCtx?.state || {}),
      ...(extraState || {})
    },
    ...rest
  }
}
